import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ["backdrop", "panel"]

  connect() {
    // Bind escape key to close
    this.boundKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown)
    this.enableScroll()
  }

  open() {
    this.element.classList.remove("hidden")
    this.disableScroll()
    
    // Reinitialize Lucide icons for modal content
    if (window.lucide) {
      window.lucide.createIcons()
    }
  }

  close() {
    this.element.classList.add("hidden")
    this.enableScroll()
  }

  handleKeydown(event) {
    if (event.key === "Escape" && !this.element.classList.contains("hidden")) {
      this.close()
    }
  }

  disableScroll() {
    document.body.style.overflow = "hidden"
  }

  enableScroll() {
    document.body.style.overflow = ""
  }
}



